import { render, staticRenderFns } from "./RemarkModal.vue?vue&type=template&id=4c6abf8b"
import script from "./RemarkModal.vue?vue&type=script&lang=js"
export * from "./RemarkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports